<template>
    <div class="fullscreen" @click.self="close">
        <div class="card">
            <sign-up-form @close="close"/>
        </div>
    </div>
</template>

<script>
import SignUpForm from './SignUpForm.vue'

export default {
    components: {
        SignUpForm
    },

    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="stylus" scoped>
.fullscreen {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
}

.card {
    background-color: #eae4e4;
    border-radius: 2px;
    color: #141414;
    position: relative;
    box-sizing: border-box;
    width: 80%;
    max-width: 520px;
    max-height: 90vh;
    overflow: scroll;
    min-height: 420px;
}
</style>
